<template>
  <div :key="group">
    <!--
    <code>Notification for {{ group }} ({{ _uid }})</code>
    -->
    <v-alert class="mb-2" :value="true" type="error" v-for="(msg, i) in messages.error" :key="'error-' + group + '-' + i">{{ msg }}</v-alert>
    <v-alert class="mb-2" :value="true" type="info" v-for="(msg, i) in messages.info" :key="'info-' + group + '-' + i">{{ msg }}</v-alert>
    <v-alert class="mb-2" :value="true" type="success" v-for="(msg, i) in messages.success" :key="'success-' + group + '-' + i">{{ msg }}</v-alert>
  </div>
</template>

<script>
export default {
  name: 'notifications',
  props: ['group'],
  data () {
    return {
      messages: {}
    }
  },
  mounted () {
    this.fetch()
  },
  destroyed () {
    this.$root.$off('consumeNotifications', this.eventHandler)
  },
  created () {
    const self = this
    this.eventHandler = arg => {
      if (arg === this.group) {
        self.fetch()
      }
    }

    this.$root.$on('consumeNotifications', this.eventHandler)
  },
  methods: {
    async fetch () {
      this.messages = await this.$store.dispatch('consumeNotifications', this.group)
    }
  }
}
</script>

<style scoped>
</style>
